document.addEventListener('DOMContentLoaded', function () {
    /**
     * Mobile Filter Drawer Logic
     */
    const filterDrawer = document.getElementById('filterDrawer');
    const filterDrawerOverlay = document.getElementById('filterDrawerOverlay');
    const openDrawerBtn = document.getElementById('openFilterDrawer');
    const closeDrawerBtn = document.getElementById('closeFilterDrawer');

    if (openDrawerBtn && filterDrawer && filterDrawerOverlay && closeDrawerBtn) {
        const toggleDrawer = (isOpen) => {
            if (isOpen) {
                filterDrawer.classList.add('drawer-open');
                filterDrawerOverlay.classList.add('active');
                document.body.style.overflow = 'hidden';
            } else {
                filterDrawer.classList.remove('drawer-open');
                filterDrawerOverlay.classList.remove('active');
                document.body.style.overflow = '';
            }
        };

        openDrawerBtn.addEventListener('click', () => toggleDrawer(true));
        closeDrawerBtn.addEventListener('click', () => toggleDrawer(false));
        filterDrawerOverlay.addEventListener('click', () => toggleDrawer(false));

        window.addEventListener('resize', () => {
            if (window.innerWidth > 1024 && filterDrawer.classList.contains('drawer-open')) {
                toggleDrawer(false);
            }
        });
    }

    /**
     * Property Filters Logic
     */
    const propertyGrid = document.getElementById('property-grid');
    if (!propertyGrid) return;

    const propertyItems = document.querySelectorAll('.property-item');
    const initialItemsArray = Array.from(propertyItems);
    const sortSelect = document.querySelector('.sort-select');

    const getActiveButtonValues = (selector) => {
        return Array.from(document.querySelectorAll(selector + '.active')).map(btn => btn.dataset.value);
    };

    const filters = {
        minPrice: 0,
        maxPrice: Infinity,
        minArea: 0,
        maxArea: Infinity,
        categories: [],
        offerings: [],
        bedrooms: [],
        statuses: [],
        amenities: []
    };

    let itemsPerPage = 12;
    let currentPage = 1;

    function updateFiltersFromDOM() {
        filters.minPrice = document.querySelector('.filter-min-price') ? (parseInt(document.querySelector('.filter-min-price').value) || 0) : 0;
        filters.maxPrice = document.querySelector('.filter-max-price') ? (parseInt(document.querySelector('.filter-max-price').value) || Infinity) : Infinity;
        filters.minArea = document.querySelector('.filter-min-area') ? (parseInt(document.querySelector('.filter-min-area').value) || 0) : 0;
        filters.maxArea = document.querySelector('.filter-max-area') ? (parseInt(document.querySelector('.filter-max-area').value) || Infinity) : Infinity;
        filters.categories = getActiveButtonValues('.filter-category');
        filters.offerings = getActiveButtonValues('.filter-offering');
        filters.bedrooms = getActiveButtonValues('.filter-bedroom').map(v => v.toString());
        filters.statuses = getActiveButtonValues('.filter-status');
        filters.amenities = getActiveButtonValues('.filter-amenity');
    }

    function syncFiltersFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
        
        const catPara = urlParams.get('property_category');
        if (catPara) {
            const btn = document.querySelector(`.filter-category[data-value="${catPara.toLowerCase()}"]`) || 
                        document.querySelector(`.filter-category[data-value="${catPara}"]`);
            if (btn) {
                btn.classList.add('active');
                updateButtonStyles(btn);
            }
        }

        const offerPara = urlParams.get('offering_type');
        if (offerPara) {
            const btn = document.querySelector(`.filter-offering[data-value="${offerPara.toLowerCase()}"]`) || 
                         document.querySelector(`.filter-offering[data-value="${offerPara}"]`);
            if (btn) {
                btn.classList.add('active');
                updateButtonStyles(btn);
            }
        }
        
        const minPricePara = urlParams.get('min_price');
        if (minPricePara) {
            const select = document.querySelector('.filter-min-price');
            if (select) {
                const options = Array.from(select.options).filter(opt => opt.value !== "");
                const val = parseInt(minPricePara);
                const option = options.reverse().find(opt => parseInt(opt.value) <= val);
                if (option) select.value = option.value;
            }
        }
        const maxPricePara = urlParams.get('max_price');
        if (maxPricePara) {
            const select = document.querySelector('.filter-max-price');
            if (select) {
                const options = Array.from(select.options).filter(opt => opt.value !== "");
                const val = parseInt(maxPricePara);
                const option = options.find(opt => parseInt(opt.value) >= val);
                if (option) select.value = option.value;
            }
        }

        const bedPara = urlParams.get('bedrooms');
        if (bedPara) {
             const btn = document.querySelector(`.filter-bedroom[data-value="${bedPara}"]`);
             if (btn) {
                 btn.classList.add('active');
                 updateButtonStyles(btn);
             }
        }

        const statusPara = urlParams.get('property_status');
        if (statusPara) {
             const btn = document.querySelector(`.filter-status[data-value="${statusPara.toLowerCase()}"]`) ||
                         document.querySelector(`.filter-status[data-value="${statusPara}"]`);
             if (btn) {
                 btn.classList.add('active');
                 updateButtonStyles(btn);
             }
        }
    }

    function updateButtonStyles(btn) {
        if (!btn) return;
        const icon = btn.querySelector('i, svg');
        if (btn.classList.contains('active')) {
            btn.classList.remove('text-dark', 'btn-outline-light');
            btn.classList.add('text-white', 'btn-warning');
            if (icon && icon.tagName.toLowerCase() === 'svg') icon.style.stroke = '#fff';
            if (icon && icon.tagName.toLowerCase() === 'i') {
                icon.classList.remove('text-muted');
                icon.classList.add('text-white');
            }
        } else {
            btn.classList.add('text-dark', 'btn-outline-light');
            btn.classList.remove('text-white', 'btn-warning');
            if (icon && icon.tagName.toLowerCase() === 'svg') icon.style.stroke = '#000';
            if (icon && icon.tagName.toLowerCase() === 'i') {
                icon.classList.add('text-muted');
                icon.classList.remove('text-white');
            }
        }
    }

    function applyFilters(resetPagination = true) {
        try {
            if (!propertyGrid) return;
            if (resetPagination) currentPage = 1;
            
            updateFiltersFromDOM();
            const urlParams = new URLSearchParams(window.location.search);
            const searchQuery = (urlParams.get('s') || '').trim().toLowerCase();

            const items = [...initialItemsArray];
            let matchCount = 0;

            items.forEach(item => {
                const price = parseInt(item.dataset.price) || 0;
                const area = parseInt(item.dataset.area) || 0;
                const categoryValue = (item.dataset.category || '').toLowerCase();
                const offeringValue = (item.dataset.offeringType || '').toLowerCase();
                const statusValue = (item.dataset.status || '').toLowerCase();
                const bedroomsValue = (item.dataset.bedrooms || '0');
                let amenities = [];
                try { amenities = JSON.parse(item.dataset.amenities || '[]'); } catch(e) { amenities = []; }
                
                const titleEl = item.querySelector('.card-title, .property-title, h5, h3');
                const title = titleEl ? titleEl.textContent.toLowerCase() : '';

                const matchesKeyword = searchQuery ? (title.includes(searchQuery) || offeringValue.includes(searchQuery) || categoryValue.includes(searchQuery)) : true;
                const matchesPrice = (price >= filters.minPrice && price <= filters.maxPrice);
                const matchesArea = (area >= filters.minArea && area <= filters.maxArea);
                const matchesCategory = filters.categories.length === 0 || filters.categories.some(c => c.toLowerCase() === categoryValue);
                const matchesOffering = filters.offerings.length === 0 || filters.offerings.some(o => o.toLowerCase() === offeringValue);
                const matchesStatus = filters.statuses.length === 0 || filters.statuses.some(s => s.toLowerCase() === statusValue);
                
                let matchesBedrooms = true;
                if (filters.bedrooms.length > 0) {
                    const itemBedsStr = (item.dataset.bedrooms || '0').toString().toLowerCase();
                    const itemBeds = itemBedsStr === 'studio' ? 'studio' : (parseInt(itemBedsStr) || 0);
                    
                    matchesBedrooms = filters.bedrooms.some(b => {
                        const bLower = b.toString().toLowerCase();
                        if (bLower === 'studio' || itemBeds === 'studio') return bLower === itemBeds;
                        
                        const val = parseInt(b);
                        // If it's 5, we treat it as 5+
                        if (val === 5) return itemBeds >= 5;
                        return itemBeds === val;
                    });
                }
                const matchesAmenities = filters.amenities.length === 0 || filters.amenities.some(am => amenities.map(a => a.toLowerCase()).includes(am.toLowerCase()));

                const isMatch = matchesKeyword && matchesPrice && matchesArea && matchesCategory && matchesOffering && matchesStatus && matchesBedrooms && matchesAmenities;
                item.dataset.priority = isMatch ? "1" : "0";
                if (isMatch) matchCount++;

                item.classList.remove('d-none');
                item.style.display = 'block';
            });

            const sortValue = sortSelect ? sortSelect.value : 'newest';
            items.sort((a, b) => {
                const pA = parseInt(a.dataset.priority) || 0;
                const pB = parseInt(b.dataset.priority) || 0;
                if (pA !== pB) return pB - pA;

                if (sortValue === 'price-asc') return (parseInt(a.dataset.price) || 0) - (parseInt(b.dataset.price) || 0);
                if (sortValue === 'price-desc') return (parseInt(b.dataset.price) || 0) - (parseInt(a.dataset.price) || 0);
                
                const dA = new Date(a.dataset.date || '2023-01-01').getTime() || 0;
                const dB = new Date(b.dataset.date || '2023-01-01').getTime() || 0;
                return dB - dA;
            });

            propertyGrid.innerHTML = '';
            
            const matchedItems = items.filter(item => item.dataset.priority === "1");
            const totalMatched = matchedItems.length;
            
            if (totalMatched === 0) {
                propertyGrid.innerHTML = '<div class="col-12 text-center py-5"><p class="text-muted">No properties found matching your criteria.</p></div>';
                renderPagination(0, 1);
                const mobileCountDisplay = document.getElementById('property-count-mobile');
                if (mobileCountDisplay) mobileCountDisplay.textContent = '0 Matches Found';
                return;
            }

            const totalPages = Math.ceil(totalMatched / itemsPerPage) || 1;
            if (currentPage > totalPages) currentPage = totalPages;
            
            const start = (currentPage - 1) * itemsPerPage;
            const end = start + itemsPerPage;

            matchedItems.forEach((item, index) => {
                if (index >= start && index < end) {
                    propertyGrid.appendChild(item);
                }
            });

            renderPagination(totalPages, currentPage);

            const mobileCountDisplay = document.getElementById('property-count-mobile');
            if (mobileCountDisplay) {
                mobileCountDisplay.textContent = `${totalMatched} Matches Found`;
            }

        } catch (err) {
            console.error("Filter Error:", err);
        }
    }

    function renderPagination(totalPages, current) {
        const pagContainer = document.getElementById('js-pagination');
        if (!pagContainer) return;
        if (totalPages <= 1) { pagContainer.innerHTML = ''; return; }

        let pages = [];
        for (let i = 1; i <= totalPages; i++) {
            if (i <= 3 || i > totalPages - 3 || (i >= current - 1 && i <= current + 1)) pages.push(i);
        }
        pages = [...new Set(pages)].sort((a, b) => a - b);

        let html = '<ul class="page-numbers">';
        html += `<li><a href="#" class="js-page ${current === 1 ? 'disabled' : ''}" data-page="${current - 1}"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="#1F2937" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></a></li>`;
        let lastPage = 0;
        for (let page of pages) {
            if (lastPage !== 0 && page - lastPage > 1) html += '<li><span class="dots">...</span></li>';
            html += `<li><span class="${page === current ? 'current' : 'js-page'}" ${page !== current ? 'data-page="'+page+'"' : ''}>${page}</span></li>`;
            lastPage = page;
        }
        html += `<li><a href="#" class="js-page ${current === totalPages ? 'disabled' : ''}" data-page="${current + 1}"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6L15 12L9 18" stroke="#1F2937" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></a></li></ul>`;
        
        pagContainer.innerHTML = html;
        pagContainer.querySelectorAll('.js-page:not(.disabled)').forEach(btn => {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                currentPage = parseInt(this.getAttribute('data-page'));
                applyFilters(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        });
    }

    syncFiltersFromURL();
    updateFiltersFromDOM();
    setTimeout(applyFilters, 100);

    document.querySelectorAll('.filter-min-price, .filter-max-price, .filter-min-area, .filter-max-area').forEach(el => {
        el.addEventListener('change', () => { updateFiltersFromDOM(); applyFilters(); });
    });

    document.querySelectorAll('.filter-category, .filter-offering, .filter-bedroom, .filter-status, .filter-amenity').forEach(btn => {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            this.classList.toggle('active');
            updateButtonStyles(this);
            updateFiltersFromDOM();
            applyFilters();
        });
    });

    if (sortSelect) sortSelect.addEventListener('change', () => applyFilters());
    
    const clearBtn = document.querySelector('.clear-all-filters');
    if (clearBtn) clearBtn.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelectorAll('.property-sidebar select').forEach(s => s.selectedIndex = 0);
        document.querySelectorAll('.property-sidebar .active').forEach(b => { b.classList.remove('active'); updateButtonStyles(b); });
        updateFiltersFromDOM();
        applyFilters();
    });
});
